export default "__VITE_ASSET__q3GuCNXo__"